import Block from 'components/Block'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextTitleLight from 'components/TextTitleLight'
import { View } from 'components/View'
import { STYLES_PADDING } from 'modules/styles/constants/index.cjs'
import React from 'react'
import {
  defineMessages,
  useIntl
} from 'react-intl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import { AppCTA } from 'pages/App/Cta/index.js'

const messages = defineMessages({
  getAppTitleDeprecated: {
    id: 'GetApp.getAppTitleDeprecated',
    defaultMessage: 'Become the best version of yourself.'
  },
  getAppTitle: {
    id: 'GetApp.getAppTitle',
    defaultMessage: 'Nutrition and Workouts in One App'
  },
  getAppSubTitle: {
    id: 'GetApp.getAppSubTitle',
    defaultMessage: 'Log meals in seconds and follow guided workout plans designed for your goals.'
  }
})

export function GetApp () {
  const intl = useIntl()
  return (
    <Block
      // bgc='backgroundContent'
      style={{
        textAlign: 'center'
      }}
    >
      <View
        ac
        jc
      >
        <TextTitleCompressedHeavy>
          {formatMessageIntlUtil(intl, messages.getAppTitle)}
        </TextTitleCompressedHeavy>
        <div
          style={{
            paddingBottom: STYLES_PADDING.BIG
          }}
        >
          <TextTitleLight>
            {formatMessageIntlUtil(intl, messages.getAppSubTitle)}
          </TextTitleLight>
        </div>

        <AppCTA isCentered />

      </View>
    </Block>
  )
}
